import { Component } from '@angular/core';
import { StudyStatsComponent } from "../study-stats/study-stats.component";

@Component({
  selector: 'app-about',
  standalone: true,
  imports: [StudyStatsComponent],
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss'
})
export class AboutComponent {

}
